import script from "./science-plan.vue?vue&type=script&setup=true&lang=js"
export * from "./science-plan.vue?vue&type=script&setup=true&lang=js"

import "./science-plan.vue?vue&type=style&index=0&id=614be7eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-614be7eb"]])

export default __exports__